(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_e162015"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qalb-contact')) {
  class QalbContact extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.qc-q').forEach((btn) => {
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!open));
          btn.closest('.qc-item').classList.toggle('is-open', !open);
        });
      });
      this.initForm();
    }

    initForm() {
      const success = this.querySelector('.qc-success');
      if (success) {
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        success.focus({ preventScroll: true });
      }

      const form = this.querySelector('form.qc-form');
      const submit = form && form.querySelector('button[type="submit"]');
      if (!form || !submit) return;

      const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      const phoneRe = /^\+?[\d\s().-]{7,18}$/;

      const setError = (el, msg) => {
        const wrap = el.closest('.qc-f');
        const out = wrap.querySelector('.qc-error');
        wrap.classList.toggle('has-error', !!msg);
        el.setAttribute('aria-invalid', msg ? 'true' : 'false');
        out.textContent = msg;
        out.hidden = !msg;
      };

      const check = (el) => {
        const v = el.value.trim();
        let msg = '';
        if (el.required && !v) msg = el.dataset.msg || 'This field is required';
        else if (el.type === 'email' && v && !emailRe.test(v)) msg = 'Enter a valid email, like name@example.com';
        else if (el.type === 'tel' && v && !phoneRe.test(v)) msg = 'Enter a valid phone number';
        else if (el.tagName === 'TEXTAREA' && v && v.length < 10) msg = 'Add a little more detail (10+ characters)';
        setError(el, msg);
        return !msg;
      };

      const fields = [...form.querySelectorAll('input:not([type="hidden"]), select, textarea')];

      fields.forEach((el) => {
        el.addEventListener('blur', () => check(el));
        const live = () => { if (el.closest('.qc-f').classList.contains('has-error')) check(el); };
        el.addEventListener('input', live);
        el.addEventListener('change', live);
      });

      form.addEventListener('submit', (e) => {
        const bad = fields.filter((el) => !check(el));
        if (bad.length) {
          e.preventDefault();
          bad[0].focus();
          return;
        }
        const first = form.querySelector('[name="contact[first_name]"]').value.trim();
        const last = form.querySelector('[name="contact[last_name]"]').value.trim();
        form.querySelector('[name="contact[name]"]').value = `${first} ${last}`.trim();

        submit.classList.add('is-loading');
        submit.setAttribute('aria-busy', 'true');
        submit.querySelector('.qc-btn__text').textContent = 'Sending…';
      });

      window.addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        submit.classList.remove('is-loading');
        submit.removeAttribute('aria-busy');
        submit.querySelector('.qc-btn__text').textContent = 'Send Message';
      });
    }
  }
  customElements.define('qalb-contact', QalbContact);
}
  } catch(e) { console.error(e); }
})();

})();
